import { mapGetters } from "vuex";

import comboComponent from "@/components/child/form/combo.vue";
import dateTimePickerComponent from "@/components/child/form/datetimepicker.vue";
import { GridAction } from "@/components/child/grid/gridAction";
import { GridColors, GridColumnSearchColor, GridColumnType } from "@/components/child/grid/gridColumn";
import ImpressaoComponent from "@/components/child/impressao/impressaoComponent";
import impressaoComponent from "@/components/child/impressao/impressaoComponent.vue";
import ConfiguracoesImpresaoXLSComponent from "@/components/parent/relatorio/configuracoesImpresaoXLS";
import configuracoesImpresaoXLSComponent from "@/components/parent/relatorio/configuracoesImpresaoXLS.vue";
import { Component, Watch } from "@/decorators";
import ConfiguracaoFranquiaModel from "@/models/configuracaoFranquia/configuracaoFranquiaModel";
import ConfiguracaoImpressaoModel from "@/models/configuracaoImpressaoModel";
import Configuracoes from "@/models/enum/configuracao/configuracoes";
import DestinosManipulacao from "@/models/enum/destinosManipulacao";
import EnumExtensions from "@/models/enum/extensions/enumExtensions";
import TipoBuscaManipulacao from "@/models/enum/manipulacao/tipoBuscaManipulacao";
import SituacoesManipulacaoOrdem from "@/models/enum/situacoesManipulacaoOrdem";
import ManipulacaoOrdemModel, { ManipulacaoOrdemListParameters } from "@/models/manipulacaoOrdemModel";
import ModeloImpressaoModel from "@/models/modeloImpressao/modeloImpressaoModel";
import PaginationModel from "@/models/paginationModel";
import estoqueService from "@/services/estoqueService";
import ManipulacaoOrdemService from "@/services/manipulacaoOrdemService";
import ModeloImpressaolService from "@/services/modeloImpressaoService";
import { Getters } from "@/store/store";
import { convertToDateInput, convertToDateInputString } from "@/utils/common/date";
import Delay from "@/utils/common/delay";
import FileHelper from "@/utils/common/fileHelper";

import ListComponentBase from "../crud/listComponentBase";
import PrintModel from "../printModel/printModel";

import "./list.scss";

@Component({
    components: {
        comboComponent,
        dateTimePickerComponent,
        impressaoComponent,
        configuracoesImpresaoXLSComponent,
    },
    computed: {
        ...mapGetters(["VALIDAR_PERMISSAO_USUARIO", "GET_CONFIG_FRANQUIA", "CONFIG_FRANQUIA_LOADED"] as Getters),
    },
})
export default class ManipulacaoOrdemListComponent extends ListComponentBase<ManipulacaoOrdemModel> {
    // State computed props
    GET_CONFIG_FRANQUIA: (configuracao: Configuracoes) => ConfiguracaoFranquiaModel;
    VALIDAR_PERMISSAO_USUARIO: (telaDescricao: string, acaoController: string) => boolean;
    CONFIG_FRANQUIA_LOADED: () => boolean;

    private manipulacaoOrdemService = new ManipulacaoOrdemService();

    private impressaoComponent: ImpressaoComponent = null;
    private configuracoesImpresaoXLSComponent: ConfiguracoesImpresaoXLSComponent = null;

    customParameters: ManipulacaoOrdemListParameters = {};

    isHidden = false;
    manipulacaoOrdemFiltro?: number = null;
    estoqueId?: number = null;
    dataFilter1: Date = null;
    dataFilter2: Date = null;
    tipoBuscaManipulacao = 1;

    situacaoManipulacaoOptions: Array<Object> = EnumExtensions.getNamesAndValuesOrderedByValues(
        SituacoesManipulacaoOrdem,
    ).filter(item => item.value !== 0);
    estoqueOptions: Array<Object> = [];
    tipoBuscaManipulacaoOptions: Array<Object> = [
        { text: "Código", value: TipoBuscaManipulacao.Codigo },
        { text: "Forma Farmacêutica", value: TipoBuscaManipulacao.FormaFarmaceutica },
        { text: "Paciente", value: TipoBuscaManipulacao.Paciente },
        { text: "Manipulação", value: TipoBuscaManipulacao.Manipulacao },
    ];

    gridSelectedValues: Array<ManipulacaoOrdemModel> = [];

    extraActions: Array<object> = [];
    gridExtraActionsImprimir: Array<GridAction> = [];
    gridExtraActionsImprimirRotulo: Array<GridAction> = [];

    get gridColumns(): Array<GridColumnSearchColor> {
        return [
            new GridColumnSearchColor("codigo", this.$t("__.ts.codigo"), GridColumnType.String, true),
            new GridColumnSearchColor("codigoVenda", this.$t("__.ts.venda"), GridColumnType.String, false),
            new GridColumnSearchColor(
                "formaFarmaceuticaDescricao",
                this.$t("__.ts.formfarmceu"),
                GridColumnType.String,
                false,
            ),
            new GridColumnSearchColor("situacaoDescricao", this.$t("__.ts.situacao"), GridColumnType.String, false),
            new GridColumnSearchColor("dataAprovacao", this.$t("__.ts.dataAprovacao"), GridColumnType.Date, true),
            new GridColumnSearchColor("dataConclusao", this.$t("__.ts.dataConclusao"), GridColumnType.Date, false),
            new GridColumnSearchColor(
                "observacao",
                this.$t("__.Crud.cliente.edit_vue_html.obs"),
                GridColumnType.String,
                false,
            ),
            new GridColumnSearchColor("franquia", this.$t("__.ts.franq"), GridColumnType.String, false),
        ];
    }

    private beforeMount() {
        this.setProps(new ManipulacaoOrdemService(), "manipulacaoordem", "dataaprovacao", false, "desc");
    }

    public async afterMounted() {
        while (!this.CONFIG_FRANQUIA_LOADED()) await Delay(100);

        this.estoqueId = this.GET_CONFIG_FRANQUIA(Configuracoes.EstoquePadrao).estoqueId;

        this.estoqueOptions = await estoqueService.comboCached(this.usuarioLogado.franquiaId);
    }

    private getFormValues(listaFiltro: any) {
        this.filtros = [];
        this.filtros.push(this.manipulacaoOrdemFiltro);
        this.filtros.push(listaFiltro.target.elements.dataFilter1.value);
        this.filtros.push(listaFiltro.target.elements.dataFilter2.value);
        this.filtros.push(this.estoqueId);

        this.pageIndex = 1;
        this.load();
    }

    private onSelectedValuesChanged(values: Array<ManipulacaoOrdemModel>) {
        this.gridSelectedValues = values;
    }

    private async concluirManipulacoes() {
        if (this.gridSelectedValues.length > 0) {
            const ids = this.gridSelectedValues.map(p => p.id);

            const sucesso = await this.manipulacaoOrdemService.concluirLista(ids).withLoading().resolveWithoutJSON();
            if (sucesso) {
                await this.$showSuccess(this.$t("__.ts.conclManipu"), this.$t("__.ts.conclManipuMsg"));
                this.load();
            }
        } else {
            this.$showWarning(this.$t("__.ts.conclManipu"), this.$t("__.ts.nenhumRegisSelec"));
        }
    }

    public async loadMethod() {
        this.customParameters = {
            situacao: this.filtros[0] != null && parseInt(this.filtros[0].toString()),
            destino: DestinosManipulacao.Venda,
            dataInicial: convertToDateInputString(this.filtros[1]),
            dataFinal: convertToDateInputString(this.filtros[2], true),
            estoqueId: this.filtros[3] != null && parseInt(this.filtros[3].toString()),
            tipoBuscaManipulacao: this.tipoBuscaManipulacao,
        };

        return await this.manipulacaoOrdemService
            .listManipulacao(
                this.gridFilterKey,
                this.gridSortKey,
                this.gridSortOrder,
                this.pags ? 1 : this.pageIndex,
                this.pags ? 999999 : this.pageSize,
                this.customParameters,
            )
            .withLoading()
            .resolveWithJSON<PaginationModel<ManipulacaoOrdemModel>>();
    }

    public async afterLoad() {
        this.gridExtraActionsImprimir.splice(0);
        this.gridExtraActionsImprimirRotulo.splice(0);
        this.extraActions.splice(0);

        for (let i = 0; i < this.gridData.length; i++) {
            if (this.VALIDAR_PERMISSAO_USUARIO("manipulacoes_venda", "ImprimirManipulacao")) {
                this.gridExtraActionsImprimir.push(
                    new GridAction(
                        "imprimir-manipulacao",
                        this.$t("__.ts.printManipu") as string,
                        "fa fa-print",
                        GridColors.DARKGRAY,
                    ),
                );
            }

            if (this.VALIDAR_PERMISSAO_USUARIO("manipulacoes_venda", "ImprimirRotuloManipulacao")) {
                this.gridExtraActionsImprimirRotulo.push(
                    new GridAction(
                        "imprimir-manipulacao-rotulo",
                        this.$t("__.ts.printRotuloManipu") as string,
                        "fa fa-tag",
                        GridColors.GREEN,
                    ),
                );
            }
        }

        this.extraActions.push(this.gridExtraActionsImprimirRotulo);
        this.extraActions.push(this.gridExtraActionsImprimir);
    }

    public async onRemoveItem(model: ManipulacaoOrdemModel) {
        this.$router.push("/manipulacaoordem-cancelamento/" + model.id);
    }

    public onCreateItem() {
        this.$router.push("/venda-edicao");
    }

    private onExtraAction(name: string, model: ManipulacaoOrdemModel) {
        this.impressaoComponent = this.$refs.impressaoComponent as ImpressaoComponent;

        if (name.trim() == "imprimir-manipulacao") {
            this.impressaoComponent
                .show({
                    modelId: model.id,
                    tipoImpressao: "Manipulacao",
                    impressaoRotulo: false,
                    impressaoSelecionarModelo: true,
                })
                .withLoading();
        } else if (name.trim() == "imprimir-manipulacao-rotulo") {
            this.impressaoComponent
                .show({
                    modelId: model.id,
                    tipoImpressao: "Manipulacao",
                })
                .withLoading();
        }
    }

    public async afterLoadPagination() {
        if (this.paginationParams.filtros != null) {
            this.filtros = this.paginationParams.filtros;

            if (this.filtros.length >= 0) {
                if (this.filtros.length >= 1) {
                    if (this.filtros[1]) {
                        this.dataFilter1 = convertToDateInput(this.filtros[1].toString());
                    }
                }
                if (this.filtros.length >= 2) {
                    if (this.filtros[2]) {
                        this.dataFilter2 = convertToDateInput(this.filtros[2].toString());
                    }
                }
            }
        }
    }

    private async imprimirSelecionados() {
        if (this.gridSelectedValues.length > 0) {
            try {
                const modelo = await new ModeloImpressaolService()
                    .GetPadraoByTelaName("manipulacao")
                    .resolveWithJSON<ModeloImpressaoModel>();

                const pages = await this.manipulacaoOrdemService
                    .getManyHTMLPage(
                        this.gridSelectedValues.map(x => x.id),
                        modelo.id,
                        1,
                        this.usuarioLogado.id,
                    )
                    .withLoading();

                const printModel = new PrintModel();
                printModel.showHTMLOnBrowser(pages.pageHtml, true);
            } catch (e) {
                await this.$showError(this.$t("__.ts.erroModeloImpressaoSemConteudo"), e.message);
            }
        } else {
            this.$showWarning(this.$t("__.ts.conclManipu"), this.$t("__.ts.nenhumRegisSelec"));
        }
    }

    @Watch("tipoBuscaManipulacao")
    private onTipoBuscaManipulacao() {
        this.load();
    }

    public downloadPDF() {
        if (this.total <= 0) {
            this.$showWarning(this.$t("__.ts.atencao"), this.$t("__.ts.nenhumRegisExport"));
            return;
        }

        this.manipulacaoOrdemService.exportPDF(
            this.gridFilterKey,
            this.gridSortKey,
            this.gridSortOrder,
            this.customParameters,
        );
    }

    public async downloadXLS() {
        if (this.total <= 0) {
            this.$showWarning(this.$t("__.ts.atencao"), this.$t("__.ts.nenhumRegisExport"));
            return;
        }

        this.configuracoesImpresaoXLSComponent = this.$refs
            .configuracoesImpresaoXLSComponent as ConfiguracoesImpresaoXLSComponent;
        this.configuracoesImpresaoXLSComponent.open();
    }

    private async onConfirmXLS(config: ConfiguracaoImpressaoModel) {
        try {
            const response = await this.manipulacaoOrdemService
                .exportXLS(
                    this.gridFilterKey,
                    this.gridSortKey,
                    this.gridSortOrder,
                    this.customParameters,
                    config.tipoExportacaoXLS,
                )
                .withLoading()
                .resolveWithResponse();
            const data = await response.blob();

            const blob = new Blob([data], { type: response.headers.get("Content-Type") });
            const fileName = response.headers.get("Content-Disposition").split("filename=")[1].split(";")[0];
            FileHelper.download(blob, fileName);
        } catch {
            this.$showError(this.$t("__.ts.erro"), this.$t("__.ts.erroExportar"));
        }
    }
}
